import React, { useState, useEffect } from 'react';
import { adminAPI } from '../services/api';
import './ScannerForm.css';

function ScannerForm({ onSubmit, onCancel }) {
    const [formData, setFormData] = useState({
        name: '',
        userIds: []
    });
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        loadCustomers();
    }, []);

    const loadCustomers = async () => {
        try {
            const response = await adminAPI.getUsers({ role: 'CUSTOMER' });
            setCustomers(response.data.data.users);
        } catch (err) {
            console.error('Failed to load customers:', err);
        }
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await onSubmit(formData);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to create scanner');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="scanner-form-container">
            <div className="scanner-form">
                <h3>Create New Scanner</h3>

                {error && <div className="error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Scanner Name *</label>
                        <input
                            type="text"
                            value={formData.name}
                            onChange={(e) => handleChange('name', e.target.value)}
                            placeholder="Enter scanner name"
                            required
                            disabled={loading}
                        />
                        <small>Serial numbers will be auto-generated. Configure webhook and security policy after creation.</small>
                    </div>

                    <div className="form-group">
                        <label>Related Customers</label>
                        <div className="customer-list">
                            <div className="customer-item">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formData.userIds.length === 0}
                                        onChange={() => handleChange('userIds', [])}
                                        disabled={loading}
                                    />
                                    <span>None</span>
                                </label>
                            </div>
                            {customers.map(customer => (
                                <div key={customer.id} className="customer-item">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={formData.userIds.includes(customer.id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    handleChange('userIds', [...formData.userIds, customer.id]);
                                                } else {
                                                    handleChange('userIds', formData.userIds.filter(id => id !== customer.id));
                                                }
                                            }}
                                            disabled={loading}
                                        />
                                        <span>{customer.name} ({customer.email})</span>
                                    </label>
                                </div>
                            ))}
                        </div>
                        <small>Select multiple customers who can access this scanner</small>
                    </div>

                    <div className="form-actions">
                        <button type="submit" disabled={loading}>
                            {loading ? 'Creating...' : 'Create Scanner'}
                        </button>
                        <button
                            type="button"
                            className="secondary"
                            onClick={onCancel}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ScannerForm;
